<template>
  <ChartDownloadOptions
    :include-csv-download-option="includeCsvDownloadOption"
    :disabled="exportInProgress || disabled"
    @download-csv="$emit('download-csv')"
    @download-png="downloadWidgetPNG"
  />
</template>

<script setup>
import { downloadPNG } from '@/helpers/fileDownload';
import { useRoute } from 'vue-router';
import { useTracking } from '@/stores/tracking/tracking';
import { useAppAuthData } from '@/stores/app/authData';
import { storeToRefs } from 'pinia';
import { useInsightsExport } from '@/stores/insights/export';
import { downloadTrackingNames } from '@/helpers/constants/downloadTrackingNames';
import ChartDownloadOptions from '@/components/insights/Chart/ChartDownloadOptions.vue';
import { useFilterDrawer } from '@/stores/filters/filterDrawer';
import { wait } from '@/helpers/wait';

const props = defineProps({
  downloadId: {
    type: String,
    required: true,
  },
  fileName: {
    type: String,
    default: '',
  },
  includeCsvDownloadOption: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['download-csv']);

const route = useRoute();
const { authData } = storeToRefs(useAppAuthData());
const { exportInProgress } = storeToRefs(useInsightsExport());

const { updateExportInProgress } = useInsightsExport();
const { projectName } = authData.value;

const filterDrawerStore = useFilterDrawer();

const downloadWidgetPNG = async () => {
  let reopenFilters = false;

  useTracking().insightsDownloadReport({
    reportName: route.name,
    downloadType: 'Individual Widgets',
    downloadLocation: 'Individual Widget',
    fileType: 'PNG',
    widgetName: downloadTrackingNames[props.downloadId],
  });

  updateExportInProgress(true);

  // Close filter drawer if open to ensure full report is captured
  if (filterDrawerStore.open) {
    reopenFilters = true;

    filterDrawerStore.open = false;

    await wait(500);
  }

  await downloadPNG({
    backgroundColor: '#ffffff',
    containerSelector: `[data-widget-id=${props.downloadId}]`,
    fileName: props.fileName || `${projectName}-${route.name}-${props.downloadId}`,
  });

  updateExportInProgress(false);

  if (reopenFilters) filterDrawerStore.open = true;
};
</script>
